var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#3fbbae",
    opacity: 0.4,
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 524.83 575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M575,450H225L200.4,332.75C197.48,315.6,210.9,300,228.52,300h343c17.62,0,31,15.6,28.12,32.73ZM447.83,275,470,175H600c33.07,0,33.13-50,0-50H430L396.6,275Z",
    transform: "translate(-100 -125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571,475,539.5,676.5A28,28,0,0,1,511.78,700H288.25a28,28,0,0,1-27.72-23.52L229,475ZM178.55,336.88A53.12,53.12,0,0,1,230.93,275H306a112.47,112.47,0,0,0-206,62.5c0,57.63,43.47,104.58,99.33,111.18Z",
    transform: "translate(-100 -125)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarIcon);
export default __webpack_public_path__ + "static/media/barIcon.4bc48523b52eb120a397a6e5dc70d13b.svg";
export { ForwardRef as ReactComponent };